module.exports = __webpack_public_path__ + "img/mobile.5fb5269b.svg";